module.exports = __webpack_public_path__ + "img/BMountedArcher64_ua.3c8f5483.webp";